import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { ControlledRadioGroup } from '@act/storybook';
import { Control } from 'react-hook-form';

export interface RadioGroupInputProps {
  control: Control<{ [key: string]: string }>;
  name: string;
  options: SurveyV2.CreateOptionJSONDto[];
  isRequired: boolean;
  togglePrompt: (prompt: SurveyV2.CreatePromptJSONDto) => void;
}

const RadioGroupInput = ({
  control,
  name,
  options,
  isRequired,
  togglePrompt,
}: RadioGroupInputProps) => {
  const formattedOptions = options.map(option => {
    return {
      label: option.text,
      value: `${option.sortOrder}`,
      callback: () => togglePrompt(option.prompt),
    };
  });

  return (
    <ControlledRadioGroup
      control={control}
      name={name}
      options={formattedOptions}
      required={isRequired}
    />
  );
};

export default RadioGroupInput;
